import React from "react";
import {
  IMPERSONATION_FLAG_KEY,
  ADMIN_RETURN_URL_KEY,
} from "../../../constants/impersonation";
import { ReactComponent as LogoutIcon } from "../../SVGcomponents/logout-icon.svg";
import styles from "./styles.module.scss";
import axios from "axios";

// Кнопка появляется только когда в клиент зашли из админки (impersonation).
// Флаг и URL админки выставляются на странице /admin-login-to-client.
export const ReturnToAdminButton: React.FC = () => {
  const isImpersonating =
    localStorage.getItem(IMPERSONATION_FLAG_KEY) === "true";

  if (!isImpersonating) return null;

  const returnToAdmin = async () => {
    const adminUrl = localStorage.getItem(ADMIN_RETURN_URL_KEY);
    localStorage.removeItem(IMPERSONATION_FLAG_KEY);
    localStorage.removeItem(ADMIN_RETURN_URL_KEY);

    try {
      await axios.post(
        `${process.env.REACT_APP_BACKEND_API_PROTOCOL}://${process.env.REACT_APP_BACKEND_API_DOMAIN}/auth/restore-admin-session`,
        {},
        { withCredentials: true },
      );
    } catch {
      // If restore fails, admin will need to re-login
    }

    window.location.href = adminUrl || "/";
  };

  return (
    <button
      type="button"
      className={styles.returnToAdmin}
      onClick={returnToAdmin}
    >
      <LogoutIcon className={styles.icon} />
      <span>Back to admin</span>
    </button>
  );
};
